// Coded-field legends for the IM Item Management transactions grid (Delphi IMD0046 ABFLAGFIELD values).
// Single source for both the grid <Lookup> (valueExpr="code" displayExpr="label") and the search-panel
// <select> options (via GetLookupStaticData, which expects {ID, Text}).

export const TRANSACTION_TYPES = [
  { code: "C", label: "Receipt" },
  { code: "T", label: "Receipt Return" },
  { code: "W", label: "Receipt Allowance - No Change" },
  { code: "U", label: "Usage" },
  { code: "R", label: "Usage Return" },
  { code: "L", label: "Usage Allowance - No Change" },
  { code: "A", label: "Adjustment" },
  { code: "M", label: "Damaged/Unavailable" },
];

export const STAGES = [
  { code: "L", label: "Canceled" },
  { code: "Q", label: "Quote" },
  { code: "P", label: "Plan" },
  { code: "F", label: "Future" },
  { code: "N", label: "Pending" },
  { code: "A", label: "Arrived/Assigned" },
  { code: "S", label: "Received/Staged" },
  { code: "C", label: "Put Away/Completed" },
];

export const STATUSES = [
  { code: "O", label: "Open" },
  { code: "H", label: "Hold" },
  { code: "L", label: "Ready To Commit Later" },
  { code: "N", label: "Ready To Commit Now" },
  { code: "Z", label: "Committed" },
];

// IMITEM.STATUS (Item Master) and IMVENDORCRDETAIL.STATUS (Vendor Cross Reference): Active / Inactive only
// (no Delete). Lot status is different (A/I/D) and reuses the shared `LotStatus` from const/Lookup.js.
export const ITEM_STATUSES = [
  { code: "A", label: "Active" },
  { code: "I", label: "Inactive" },
];

// OM Transactions sub-tab — OMTRANSACTIONHEADER.TRANSACTIONTYPE (Delphi frmIMM0063).
export const OM_TRANSACTION_TYPES = [
  { code: "I", label: "Invoice" },
  { code: "C", label: "Credit" },
  { code: "J", label: "Journal" },
];

// Inventory vs non-inventory detail lines — PO/OM detail "Type" (INVENTORYTYPE / DETAILTYPE).
export const INVENTORY_TYPES = [
  { code: "I", label: "Inventory" },
  { code: "N", label: "Non-Inventory" },
];

// --- Coded business values (drive behaviour, not just display legends) --------------------------
// The Transaction Entry components (Delphi uIMD0019) branch on these codes — what is editable, which
// quantity column is written, etc. Named here (server side: Constants.Modules / RecordTypes /
// TransactionStatusConstants) so the behaviour-carrying literals aren't bare strings in the JSX.

// IMTRANSACTIONHEADER.MODULE / RECORDTYPE written by the entry form.
export const MODULE_IM = "IM";
export const RECORD_TYPE_R = "R";

// IMTRANSACTIONHEADER.STATUS codes used behaviourally (full display legend in STATUSES above).
export const STATUS_OPEN = "O";
export const STATUS_COMMITTED = "Z";

// Transaction types whose location quantity posts to OUT_SHIPPED instead of IN_RECEIVING (Usage/Shipment).
export const SHIPMENT_TRANSACTION_TYPES = ["U", "S"];

// Field enable/disable business rules (Delphi ControlHeaderFields / edtTransactionTypeChange, uIMD0019.PAS).
export const STAGE_COMPLETED = "C";
export const TRANSACTION_TYPE_USAGE = "U";            // seeded on a new header (Delphi AfterInsert)
export const TRANSACTION_TYPE_ADJUSTMENT = "A";      // forces Stage = Completed on a new header
export const TRANSACTION_TYPE_DAMAGED = "M";         // disables the location Available flag
export const TRANSACTION_TYPE_RECEIPT_ALLOWANCE = "W"; // disables the Unit Price field
// Types for which the Stage field is editable (Usage / Usage Return / Receipt / Receipt Return); the rest
// (Usage Allowance / Adjustment / Receipt Allowance / Damaged) disable it.
export const STAGE_EDITABLE_TRANSACTION_TYPES = ["U", "R", "C", "T"];

// IMTRANSACTIONLOCATION.AVAILABLEFLAG.
export const AVAILABLE_FLAG_YES = "Y";
export const AVAILABLE_FLAG_NO = "N";

// codeType for the Available "reason" lookup (wm/Lookup/GetCodes).
// IMCODES.CODETYPE behind IMTRANSACTIONLOCATION.AVAILABLEREASONCODE. Delphi carries it on the
// control's Tag - edtDetailLocationReasonCode has Tag 99 (uIMD0019.dfm), and the BaseWhere is built
// as FormatFloat('00', Tag). Was "02", which is a WM code type and returned the wrong list.
export const REASON_CODE_TYPE = "99";

// Map to the {ID, Text} shape the dynamic-form GetLookupStaticData helper expects.
export const toSelectOptions = (list) => list.map((x) => ({ ID: x.code, Text: x.label }));
